export default __webpack_public_path__ + "static/media/eseis-logo-white.33b4ada4.svg";